export const MENU_VENUE_OPTION_CHANGE_CLUB = 'changeClub';
export const MENU_VENUE_OPTION_ADD_CLUB = 'addClub';
export const MENU_VENUE_OPTION_SETTINGS = 'settings';
export const MENU_VENUE_OPTION_USERS_MANAGEMENT = 'usersManagement';
